import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Form from "src/components/Form";
import Heading from "src/components/Heading";
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs'

const Centered = ({ blok }) => {
  return (
    <SbEditable content={blok}>
      <div className="my-16 mx-4 overflow-hidden sm:mx-6 lg:mx-8 lg:my-24">
        <div className="relative max-w-xl mx-auto 2xl:max-w-screen-2xl">
          <div className="text-center 2xl:max-w-3xl mx-auto">
            <CustomBreadcrumbs className="lg:mb-10 mb-6"/>
            <Heading size="h2" className="prose text-darkblue mb-8 brightgreenBold">
                <RichText>{blok.title}</RichText>
            </Heading>
            <div className="prose md:text-base text-sm text-darkblue-700">
              <RichText>{blok.description}</RichText>
            </div>
          </div>
          <div className="mt-12 2xl:max-w-3xl mx-auto">
          { blok.form && <Form blok={blok.form[0]} /> }
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default Centered;